import { Tabs as _Tabs, TabsProps as _TabsProps } from 'antd'

export type TabProps = _TabsProps
export default function Tabs(props: TabProps) {
  return <_Tabs {...props} />
}
